import { fieldOptionsFactory, IFormItem, IFormSchema, Watch } from 'spark-forms';
import { StringEx } from '../../../Utilities/StringEx';
import { objectUtil } from '../../helpers/object';
import { IRule } from './IRule';
import { IRecurrenceRule } from './recurrence/IRecurrenceRule';
import { recurrenceRuleSchema } from './recurrence/recurrenceRuleSchema';
import { translate } from '../../../Locales/i18n/localizationService';

export const ruleSchema: IFormSchema<IRule> = {
    fields: {
        name: fieldOptionsFactory.string({ 
			displayName: translate.t("Common.Name"),
			validation: {
				validationMark: 'required',
				validationRule: async item => {
					if (StringEx.isNullOrWhiteSpace(item.name)) {
						return translate.t("Rule.RuleMustBeNamed");
					}
				}
			}
		}),
        recurring: fieldOptionsFactory.boolean({
            displayName: translate.t("Rule.Recurring"),
            description: translate.t("Rule.RecurringDescription"),
        }),
        start: fieldOptionsFactory.date({
            displayName: translate.t("Common.Start"),
            description: translate.t("Rule.StartDescription"),
            hide: item => item.recurring,
			validation: {
				validationMark: 'required',
				validationRule: async item => {
					if (!item.recurring && !item.start) {
						return translate.t("Rule.StartMustBeSpecified");
					}
				}
			}
        }),
        end: fieldOptionsFactory.date({
            displayName: translate.t("Common.End"),
            description: translate.t("Rule.EndDescription"),
            hide: item => item.recurring,
			validation: {
				validationMark: 'required',
				validationRule: async item => {
					if (!item.recurring && !item.end) {
						return translate.t("Rule.EndMustBeSpecified");
					}
					if (!item.recurring && item.start > item.end) {
						return translate.t("Rule.EndMustBeAfterStart");
					}
				}
			}
        }),
        includeWeekends: fieldOptionsFactory.boolean({
            displayName: translate.t("Rule.IncludeWeekends"),
            description: translate.t("Rule.IncludeWeekendsDescription"),
            hide: item => item.recurring,
        }),
        work: fieldOptionsFactory.number({ 
			displayName: translate.t("Common.Work"), 
			description: translate.t("Rule.WorkDescription"),
			validation: {
				validationMark: 'required',
				validationRule: async item => {
					if (item.work == null || item.work < 0) {
						return translate.t("Rule.WorkValidation");
					}
				}
			}
		}),
        recurrenceRule: fieldOptionsFactory.formItem({
            displayName: translate.t("Rule.RecurrenceRuleSettings"),
            config: { 
				schema: { 
					schema: recurrenceRuleSchema 
				},
				watch: {
					frequency: (item: IRecurrenceRule) => {
						const clone = objectUtil.deepClone(item);
						clone.day = null;
						clone.dayOfWeek = null;
						clone.daysOfWeek = null;
						clone.months = null;
						clone.ordinalWeek = null;
						return clone;
					}
				} as Watch<IFormItem>,
			},
            hide: item => !item.recurring,
        }),
    },
};
